/* eslint-disable quotes */
export default {
  titleSection: {
    title: `Retrouvez la TV d'Orange sur`,
    rs: [
      {
        name: 'facebook',
        linkRef: 'confetti.public.urls.footerFacebook',
        label: 'Suivez nous sur Facebook (nouvelle fenêtre)'
      },
      {
        name: 'twitter',
        linkRef: 'confetti.public.urls.footerTwitter',
        label: 'Suivez nous sur Twitter  (nouvelle fenêtre)'
      }
    ]
  },
  linksSection: {
    services: {
      title: 'Services TV d’Orange',
      servicesLinks: [
        {
          name: 'tv_en_direct',
          linkRef: 'confetti.public.urls.footerHomeLive',
          label: 'TV en direct',
          ariaLabel: 'TV en direct'
        },
        {
          name: 'programme_tv',
          linkRef: 'confetti.public.urls.footerProgTV',
          label: 'Programme TV',
          ariaLabel: 'Programme TV'
        },
        {
          name: 'mes_enregistrements',
          linkRef: 'confetti.public.urls.footerNpvr',
          label: 'Mes enregistrements',
          ariaLabel: 'Mes enregistrements'
        },
        {
          name: 'replay',
          linkRef: 'confetti.public.urls.footerHomeReplay',
          label: 'Replay',
          ariaLabel: 'Replay'
        },
        {
          name: 'video_a_la_demande',
          linkRef: 'confetti.public.urls.footerHomeVod',
          label: 'Vidéo à la demande',
          ariaLabel: 'Vidéo à la demande'
        }
      ]
    },
    options: {
      title: 'Bouquets et options TV',
      optionsLinks: [
        {
          name: 'boutique_tv',
          linkRef: 'confetti.public.urls.footerStore',
          label: 'Boutique TV',
          ariaLabel: 'Boutique TV'
        },
        {
          name: 'options_equipements',
          linkRef: 'confetti.public.urls.footerOptionTV',
          label: 'Options et équipements TV',
          ariaLabel: 'Options et équipements TV'
        }
      ]
    },
    assist: {
      title: 'Aide en ligne',
      assistLinks: [
        {
          name: 'assist_direct',
          linkRef: 'confetti.public.urls.support.liveAssistance',
          label: 'Assistance TV en direct',
          ariaLabel: 'Assistance TV en direct (nouvelle fenêtre)'
        },
        {
          name: 'assist_replay',
          linkRef: 'confetti.public.urls.support.replayAssistance',
          label: 'Assistance Replay',
          ariaLabel: 'Assistance Replay (nouvelle fenêtre)'
        },
        {
          name: 'assist_vod',
          linkRef: 'confetti.public.urls.support.vodAssistance',
          label: 'Assistance VOD',
          ariaLabel: 'Assistance VOD (nouvelle fenêtre)'
        }
      ]
    },
    general: {
      title: 'Informations générales',
      generalLink: [
        {
          name: 'conditions_tv',
          linkRef: 'confetti.public.urls.footerCGV',
          label: `Conditions de la TV d'Orange`,
          ariaLabel: `Conditions de la TV d'Orange (nouvelle fenêtre)`
        }]
    }
  },
  srOnly: 'Plan du site',
  infoTvSection: `La TV d'Orange est disponible sur décodeur TV, Smart TV, Clé TV, Web et application mobile.`,
  lvoSection: {
    title: `Mon Lecteur VOD`,
    iconDescription: `Regardez la vidéo que vous avez achetée ou louée, ou téléchargez la copie numérique.`,
    description: `Sur votre ordinateur PC ou Mac, profitez du service vidéo à la demande (VOD) qui propose un catalogue de plus de 30000 vidéos.`,
    buttons: {
      download: {
        label: 'Télécharger',
        linkRefWin: 'confetti.public.urls.footerDownloadMlvWin',
        linkRefMac: 'confetti.public.urls.footerDownloadMlvMac',
        ariaLabel: 'Télécharger mon lecteur VOD',
        stat: '$stats.bannerDevices.onClickFooter()'
      },
      more: {
        label: 'En savoir plus',
        linkRef: 'confetti.public.urls.footerMoreMlv',
        ariaLabel: 'En savoir plus sur mon lecteur VOD (nouvelle fenêtre)'
      }
    }
  },
  appSection: {
    appLinks: [
      {
        alt: `Téléchargez l'application TV d'Orange pour IOS (nouvelle fenêtre)`,
        dataWptv: 'mobile-app-section-app-store',
        imageLocation: '/images/available-on-app-store.png',
        linkRef: 'confetti.public.urls.footerAppStore',
        name: 'app-store',
        statName: 'app_store'
      },
      {
        alt: `Téléchargez l'application TV d'Orange pour Android (nouvelle fenêtre)`,
        dataWptv: 'mobile-app-section-play-store',
        imageLocation: '/images/available-on-play-store.png',
        linkRef: 'confetti.public.urls.footerPlayStore',
        name: 'play-store',
        statName: 'google_play'
      }
    ],
    title: 'L’app mobile TV d’Orange'
  }
}
